// extracted by mini-css-extract-plugin
export var blogArticleHero = "blogArticleHero-module--blogArticleHero--a17f6";
export var blogAuthorThumbnailContainer = "blogArticleHero-module--blogAuthorThumbnailContainer--5594c";
export var blogCategoryButton = "blogArticleHero-module--blogCategoryButton--a6fb0";
export var description = "blogArticleHero-module--description--81d64";
export var headlineContainer = "blogArticleHero-module--headlineContainer--9731c";
export var heroImage = "blogArticleHero-module--heroImage--12864";
export var infoContainer = "blogArticleHero-module--infoContainer--a3303";
export var noImage = "blogArticleHero-module--noImage--b1fc3";
export var noImageInfo = "blogArticleHero-module--noImageInfo--58044";
export var textContainer = "blogArticleHero-module--textContainer--bd13e";